<div class="chart_container">
    <canvas #lineChartWrapper></canvas>
</div>
